import {
  TEMPLATE,
  LIST_COMPANY_TEMPLATE,
  COMPANY_TEMPLATE_SHIFT_CONFIG,
  GENERATE_EVENT_STATS,
  UPDATE_COMPANY_TEMPLATE_ORDER,
  DELETE_TEMPLATE_SHIFT_CONFIG,
  SYNC_COMPANY_TEMPLATE,
  TEMPLATE_PAUSE_STATUS,
  COMPANY_ADMIN_TEMPLATE,
  UPDATE_TEMPLATE_NOTIFICATION
} from "../../constants/apis";
import { getUrl, replaceMultiple } from "../../utilities/helpers";

export const addTemplate =
  (payload) =>
  (dispatch, getState, { apiReport }) => {
    return apiReport
      .post(TEMPLATE, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const updateTemplate =
  (uuid, payload) =>
  (dispatch, getState, { apiReport }) => {
    return apiReport
      .put(`${TEMPLATE}/${uuid}`, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

  export const updateCompanyTemplate =
  (company_uuid,uuid, payload) =>
  (dispatch, getState, { apiReport }) => {
    const url = replaceMultiple(COMPANY_ADMIN_TEMPLATE, {"{{company_uuid}}":company_uuid,'{{template_uuid}}':uuid})
    return apiReport
      .put(url, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };
  
export const syncTemplate =
  (payload) =>
  (dispatch, getState, { apiReport }) => {
    return apiReport
      .post(SYNC_COMPANY_TEMPLATE, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const deleteTemplate =
  (uuid) =>
  (dispatch, getState, { apiReport }) => {
    return apiReport
      .delete(`${TEMPLATE}/${uuid}`)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };
  
export const pauseStatusUpdate=
(uuid,payload)=>
(dispatch, getState, {apiReport})=>{
  const url = replaceMultiple(TEMPLATE_PAUSE_STATUS,{"{{uuid}}":uuid})
  return apiReport
  .put(url,payload)
  .then(result=> result)
  .catch((error)=>{
    throw error;
  })
}


export const updateTemplateNotification =
  (uuid, payload) =>
  (dispatch, getState, { apiReport }) => {
    const url = replaceMultiple(UPDATE_TEMPLATE_NOTIFICATION, { "{{uuid}}": uuid });
    return apiReport
      .put(url, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchTemplate =
  (uuid) =>
  (dispatch, getState, { apiReport }) => {
    return apiReport
      .get(`${TEMPLATE}/${uuid}`)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchTemplates =
  (filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(TEMPLATE, filters);
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };
export const updateOrderCompanyTemplates =
  (uuid, payload, filter = {}) =>
  (dispatch, getState, { apiReport }) => {
    const formattedUrl = replaceMultiple(UPDATE_COMPANY_TEMPLATE_ORDER, {
      "{{uuid}}": uuid,
    });
    const url = getUrl(formattedUrl, filter);
    return apiReport
      .put(url, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchCompanyTemplates =
  (uuid, filter = {}) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(`${LIST_COMPANY_TEMPLATE}/${uuid}`, filter);
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchCompanyTemplatesShiftConfig =
  (filter = {}) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(`${COMPANY_TEMPLATE_SHIFT_CONFIG}`, filter);
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const deleteCompanyTemplateShiftConfig =
  (config_id) =>
  (dispatch, getState, { apiReport }) => {
    const url = replaceMultiple(DELETE_TEMPLATE_SHIFT_CONFIG, {
      "{{config_id}}": config_id,
    });
    return apiReport
      .delete(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const updateCompanyTemplatesShiftConfig =
  (payload = {}) =>
  (dispatch, getState, { apiReport }) => {
    return apiReport
      .post(COMPANY_TEMPLATE_SHIFT_CONFIG, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const syncTemplateEvents =
  (filter = {}) =>
  (dispatch, getState, { apiReport }) => {
    return apiReport
      .get(GENERATE_EVENT_STATS)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };
